// @flow
import _ from 'lodash';
import { KlaviyoAction } from 'stores/flow-type/klaviyo.type';
import {
  KLAVIYO_STATUS,
  GET_KLAVIYO_STATUS_REQUEST,
  GET_KLAVIYO_STATUS_SUCCESS,
  GET_KLAVIYO_STATUS_FAILURE,
  TOGGLE_KLAVIYO_REQUEST,
  TOGGLE_KLAVIYO_SUCCESS,
  TOGGLE_KLAVIYO_FAILURE,
  UPDATE_KLAVIYO_BANNER_REQUEST,
  UPDATE_KLAVIYO_BANNER_SUCCESS,
  UPDATE_KLAVIYO_BANNER_FAILURE
} from '../flow-type/klaviyo.type';

type KlaviyoState = {
  status: string,
  getStatusLoading: boolean,
  getStatusSuccess: boolean,
  webFeeds: Array<any>,
  newWebFeeds: Array<any>,
  toggleStatusLoading: boolean,
  toggleStatusSuccess: boolean,
  showDashboardBanner: boolean,
  showKlaviyoBanner: boolean
};

const initialState: KlaviyoState = {
  status: KLAVIYO_STATUS.INACTIVE,
  getStatusLoading: false,
  getStatusSuccess: false,
  webFeeds: [],
  newWebFeeds: [],

  toggleStatusLoading: false,
  toggleStatusSuccess: false,
  showDashboardBanner: false,
  showKlaviyoBanner: false
};

const klaviyoReducers = (state: KlaviyoState = initialState, action: KlaviyoAction) => {
  const { type } = action;

  switch (type) {
    case GET_KLAVIYO_STATUS_REQUEST:
      return {
        ...state,
        getStatusSuccess: false,
        getStatusLoading: true
      };
    case GET_KLAVIYO_STATUS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        status: _.get(data, 'klaviyoOAuth.status'),
        webFeeds: _.get(data, 'klaviyoOAuth.webFeeds', []),
        newWebFeeds: _.get(data, 'klaviyoOAuth.newWebFeeds', []),
        showDashboardBanner: _.get(data, 'klaviyoOAuth.showDashboardBanner', false),
        showKlaviyoBanner: _.get(data, 'klaviyoOAuth.showKlaviyoBanner', false),
        getStatusLoading: false,
        getStatusSuccess: true,
        error: undefined
      };
    }
    case GET_KLAVIYO_STATUS_FAILURE:
      return {
        ...state,
        getStatusLoading: false,
        getStatusSuccess: false,
        error: action.payload
      };

    case TOGGLE_KLAVIYO_REQUEST: {
      const status = action.payload;
      return {
        ...state,
        status,
        toggleStatusSuccess: false,
        toggleStatusLoading: true
      };
    }
    case TOGGLE_KLAVIYO_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        status: _.get(data, 'data.klaviyoOAuth.status'),
        toggleStatusLoading: false,
        toggleStatusSuccess: true,
        error: undefined
      };
    }
    case TOGGLE_KLAVIYO_FAILURE:
      return {
        ...state,
        status: !state.status,
        toggleStatusLoading: false,
        toggleStatusSuccess: false,
        error: action.payload
      };

    case UPDATE_KLAVIYO_BANNER_REQUEST: {
      const { showDashboardBanner, showKlaviyoBanner } = action.payload;
      if (!_.isNil(showDashboardBanner)) {
        return {
          ...state,
          error: undefined,
          showDashboardBanner
        };
      }
      if (!_.isNil(showKlaviyoBanner)) {
        return {
          ...state,
          error: undefined,
          showKlaviyoBanner
        };
      }

      return state;
    }
    case UPDATE_KLAVIYO_BANNER_SUCCESS: {
      return {
        ...state,
        error: undefined
      };
    }
    case UPDATE_KLAVIYO_BANNER_FAILURE: {
      const { data, error } = action.payload;
      if (!_.isNil(data?.showDashboardBanner)) {
        return {
          ...state,
          error,
          showDashboardBanner: !data?.showDashboardBanner
        };
      }
      if (!_.isNil(data?.showKlaviyoBanner)) {
        return {
          ...state,
          error,
          showKlaviyoBanner: !data?.showKlaviyoBanner
        };
      }

      return state;
    }
    default:
      return state;
  }
};

export default klaviyoReducers;
